import type { ComponentType } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";

export type RouteComponents = {
  Home: ComponentType;
  Services: ComponentType;
  Process: ComponentType;
  Company: ComponentType;
  Contact: ComponentType;
  NotFound: ComponentType;
  HowNexusWorks: ComponentType;
  WhyNexus: ComponentType;
  Sourcing: ComponentType;
  FreightForwarding: ComponentType;
  Consolidation: ComponentType;
  Inspection: ComponentType;
  ChinaTrademark: ComponentType;
  NdaNnnAgreements: ComponentType;
  SupplierVerification: ComponentType;
  ProductDevelopment: ComponentType;
  ProductionManagement: ComponentType;
  Privacy: ComponentType;
  Terms: ComponentType;
};

export function AppRoutes({ pages }: { pages: RouteComponents }) {
  const {
    Home, Services, Process, Company, Contact, NotFound, HowNexusWorks, WhyNexus,
    Sourcing, FreightForwarding, Consolidation, Inspection, ChinaTrademark, NdaNnnAgreements,
    SupplierVerification, ProductDevelopment, ProductionManagement, Privacy, Terms,
  } = pages;

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="services/sourcing" element={<Sourcing />} />
        <Route path="services/freight-forwarding" element={<FreightForwarding />} />
        <Route path="shipping-quote" element={<Navigate to="/services/freight-forwarding/#freight-quote" replace />} />
        <Route path="services/consolidation" element={<Consolidation />} />
        <Route path="services/inspection" element={<Inspection />} />
        <Route path="services/product-photography" element={<Navigate to="/services/" replace />} />
        <Route path="services/amazon-fba-management" element={<Navigate to="/services/" replace />} />
        <Route path="services/custom-websites" element={<Navigate to="/services/" replace />} />
        <Route path="services/custom-software" element={<Navigate to="/services/" replace />} />
        <Route path="services/shopify-development" element={<Navigate to="/services/" replace />} />
        <Route path="services/china-trademark" element={<ChinaTrademark />} />
        <Route path="services/nda-nnn-agreements" element={<NdaNnnAgreements />} />
        <Route path="services/supplier-verification" element={<SupplierVerification />} />
        <Route path="services/product-development" element={<ProductDevelopment />} />
        <Route path="services/production-management" element={<ProductionManagement />} />
        <Route path="process" element={<Process />} />
        <Route path="how-nexus-works" element={<HowNexusWorks />} />
        <Route path="why-nexus" element={<WhyNexus />} />
        <Route path="about" element={<Company />} />
        <Route path="company" element={<Navigate to="/about/" replace />} />
        <Route path="contact" element={<Contact />} />
        <Route path="start-project" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
